export const findPackageById = (packageId, options, initialPackageVariants) => {
  if (initialPackageVariants?.show_quick_variants_selection_type === 1) {
    return options.find((opt) => opt.package_id === parseInt(packageId));
  } else {
    for (const option of options || []) {
      for (const cls of option.classes || []) {
        for (const duration of cls.durations || []) {
          for (const medium of duration.mediums || [{}]) {
            for (const pkg of medium.packageInfo ||
              duration.packageInfo ||
              []) {
              if (pkg.package_id === parseInt(packageId)) {
                return pkg;
              }
            }
          }
        }
      }
    }
  }
  return null;
};
export const chunkArray = (array, size) => {
  if (!Array.isArray(array) || size <= 0) return [];
  const result = [];
  for (let i = 0; i < array.length; i += size) {
    result.push(array.slice(i, i + size));
  }
  return result;
};

export const getPlainText = (html) => {
  if (!html || typeof html !== "string") return "";
  return html.replace(/<[^>]+>/g, "").trim();
};

export const togglePackage = (prevPackages, pkg, packageId) => {
  const isSelected = prevPackages.some((p) => p.package_id === packageId);
  if (isSelected) {
    return prevPackages.filter((p) => p.package_id !== packageId);
  }
  return [
    ...prevPackages,
    {
      package_id: pkg.package_id,
      package_name: pkg.package_name,
      amount: pkg.amount || "0",
      duration: pkg.duration || "",
      discount: pkg.discount || "0",
      course_id: pkg.course_id || "",
    },
  ];
};

export const formatPrice = (value) => Number(value || 0).toFixed(2);

export const formatExpiryDate = (expiryDate) => {
  if (!expiryDate || expiryDate === "0000-00-00") return "";
  const dateObj = new Date(expiryDate);
  if (isNaN(dateObj.getTime())) return "";
  const day = dateObj.getDate();
  const month = dateObj.getMonth() + 1;
  const year = dateObj.getFullYear();
  return `${day}-${month}-${year}`;
};
